const icelandPhotos = {
    id: 'best-photos-iceland',
    type: 'photoPost',
    countryId: 'iceland',
    title: 'Best of Iceland: Photos',
    month: 'July',
    date: '13',
    content: [
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Urriðafoss.jpg',
            detailText: 'Small waterfalls off to the side of Urriðafoss.'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/waterfall2.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/waterfall1.jpg'],
            detailText: 'We picked up Shita and Hirate hitchhiking on the road south of Reykjavik on our first day, and went to Gljúfrabúi together. You have to rock hop through a tiny canyon to get into here.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/airplane.jpg',
            detailText: 'The downed plane at Sólheimajökull'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Reynisfjara.jpg',
            detailText: 'Reynisfjara'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/blacksand.jpg',
            detailText: 'Black beaches at Reynisfjara'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/green.jpg',
            detailText: 'A shock of green somewhere off the southern Ring Road.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Þakgil1.jpg',
            detailText: 'Þakgil'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Þakgil2.jpg',
            detailText: 'Þakgil'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Skaftafell.jpg',
            detailText: 'The glacier at Skaftafell'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Bridge.jpg',
            detailText: 'Weather patterns and an old Ring Road bridge'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Jökulsárlón.jpg',
            detailText: 'Jökulsárlón'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Jökulsárlón2.jpg',
            detailText: 'Glaciers wash up on the black beach at Jökulsárlón'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Jökulsárlón3.jpg',
            detailText: 'Jökulsárlón lake'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Laugavellir.jpg',
            detailText: 'The hot waterfall at Laugavellir'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Njamafell.jpg',
            detailText: 'Njamafell'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Peter.jpg',
            detailText: 'Peter practicing photography'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Goðafoss1.jpg',
            detailText: 'Goðafoss, with our amateur photography skills'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Goðafoss2.jpg',
            detailText: 'Goðafoss, as taken by a semi-professional photographer we met there'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/herring1.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/herring2.jpg'],
            detailText: 'Siglufjörður, known for its herring'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/horses.jpg',
            detailText: 'The beautiful Icelandic horses'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Hofsos.jpg',
            detailText: 'Hofsós pool'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Fosslaug.jpg',
            detailText: 'The waterfall at Fosslaug'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Fosslaug3.jpg',
            detailText: 'The hotpot at Fosslaug'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/roadview.jpg',
            detailText: 'A view from the Ring Road'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Dynjandi1.jpg',
            detailText: 'Waterfalls on waterfalls at Dynjandi'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Dynjandi2.jpg',
            detailText: 'Dynjandi'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Dynjandi3.jpg',
            detailText: 'Dynjandi'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/shipwreck.jpg',
            detailText: 'Shipwreck in the Westfjords'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/puffin1.jpg',
            detailText: 'A puffin on the Látrabjarg cliffs'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/puffin2.jpg',
            detailText: 'Seabirds at Látrabjarg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Rauðasandur.jpg',
            detailText: 'The red sand beach of Rauðasandur'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Reykjafjarðarlaug2.jpg',
            detailText: 'Soaking in the hot springs at Reykjafjarðarlaug'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Reykjafjarðarlaug.jpg',
            detailText: 'The heated pool at Reykjafjarðarlaug'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/rainbow.jpg',
            detailText: 'A rainbow off the Ring Road'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/rainbowmountain.jpg',
            detailText: 'A rainbow mountain at Landmannalaugar'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/LandmannalaugarUs.jpg',
            detailText: 'Starting the 4-day Laugavegur trek'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/AllSnow.jpg',
            detailText: 'Snowed out on the trail'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Landmannalaugar1.jpg',
            detailText: 'Landmannalaugar'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Landmannalaugar2.jpg',
            detailText: 'Landmannalaugar'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/River.jpg',
            detailText: 'River crossing on Laugavegur'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Laugavegur.jpg',
            detailText: 'Laugavegur'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Þórsmörk.jpg',
            detailText: 'Þórsmörk'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/LaugarvatnFontana.jpg',
            detailText: 'Recuperating from the trek at Laugarvatn Fontana'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Gjáin.jpg',
            detailText: 'Gjáin'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Gjáin2.jpg',
            detailText: 'Gjáin'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Gjáin3.jpg',
            detailText: 'Gjáin, again!'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/bestphotosiceland/Gjáin4.jpg',
            detailText: 'Peter gets moody at Gjáin'
        }
    ]
}


export default icelandPhotos


// WEBPACK FOOTER //
// ./src/Posts/Content/IcelandPhotos.js